import { ClassicPreset as Classic } from 'rete';

export class TaskGroupNode extends Classic.Node {
  public groupKey: string | number;
  public visible = true;
  public contentVisible = false;
  public selected = false;
  public toggleContentVisibility?: () => void;
  public toggleGroupVisibility?: () => void;
  public ungroup?: () => void;
  public taskCount = 0;
  public title: string;
  public width = 1;
  public height = 1;
  public managedPosition = false;

  constructor(key: string | number, title: string) {
    super(title || `Group ${key}`);
    this.title = title || `Group ${key}`;
    this.groupKey = key;
    this.id = `group-${String(key)}`;
  }
}
